import de from './de';
import en from './en';
import es from './es';
import fi from './fi';
import fr from './fr';
import no from './no';
import sv from './sv';

export default { en, es, sv, no, de, fr, fi };
